import { POST } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface user {
  email: string | null;
  first_name: string;
  last_name: string;
  roles: string;
  customerId: string | null;
  accessToken: string | null;
  card: boolean;
  application_access: boolean;
  futurePayment: boolean;
  refreshToken: string | null;
  loading: boolean;
  avatar: string;
  business_id: string | null;
}

export const initialState: user = {
  email: null,
  first_name: '',
  last_name: '',
  roles: '',
  customerId: null,
  card: false,
  application_access: false,
  accessToken: null,
  refreshToken: null,
  loading: false,
  futurePayment: false,
  // user: null,
  avatar: "",
  business_id: null,
};
const { signup, signin } = API_ROUTES;

export const registerUser = createAsyncThunk(
  "/api/signup",
  async (
    data: { email: string; password: string; confirmPassword: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await POST(signup, data);
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const loginUser = createAsyncThunk(
  "/api/login",
  async (
    { email, password }: { email: string; password: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await POST(signin, { email, password });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "/api/resetpassword",
  async ({ email }: { email: string }, { rejectWithValue }) => {
    try {
      const response = await POST(signin, { email });
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.email = null;

      // state.user = null;
      state.business_id = null;
      state.customerId = null
      state.first_name = ''
      state.last_name = ''
    },
    upadateUser: (state, action) => {
      // state.user = {
      //   ...state.user,
      //   first_name: action.payload.first_name,
      //   last_name: action.payload.last_name,
      //   email: action.payload.email,
      // };
      state.first_name = action.payload.first_name,
        state.last_name = action.payload.last_name,
        state.email = action.payload.email,
        state.avatar = action.payload.avatar;
    },
    upadateApplicationAccess: (state, action) => {
      state.application_access = action.payload
    },
    upadateFuturePayments: (state, action) => {
      state.futurePayment = action.payload
    },
    updateCardInfo: (state, action: PayloadAction<{
      cardStatus: boolean;
      application_access?: boolean;
    }>) => {
      state.card = action.payload.cardStatus
      if (action.payload?.application_access) {
        state.application_access = action.payload?.application_access
      }
    },
    updateAccessToken: (state, action) => {
      state.accessToken = action.payload.accessToken
    },
    updateRefreshToken: (state, action) => {
      state.refreshToken = action.payload.refreshToken
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(loginUser.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(loginUser.fulfilled, (state, { payload }) => {
        const { accessToken, refreshToken, user, } = payload;
        state.loading = false;
        state.email = user.email;
        state.first_name = user.first_name
        state.last_name = user.last_name
        state.roles = user.roles
        state.business_id = user?.business_id;
        state.accessToken = accessToken;
        state.avatar = user.avatar;
        state.refreshToken = refreshToken;
        state.customerId = user.customer_id
        state.card = user.card_status
        state.futurePayment = user.futurePayment
        state.application_access = user.application_access
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { logout, upadateUser, updateCardInfo, upadateApplicationAccess, upadateFuturePayments, updateAccessToken, updateRefreshToken } = userSlice.actions;
export default userSlice.reducer;
